export default "__VITE_ASSET__CKrVpN_T__"